import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from '../../../../../i18n/en.json';
import spanish from '../../../../../i18n/es.json';
import portuguese from '../../../../../i18n/pt.json';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../@fuse/services/translation-loader.service";
import * as i2 from "@ngx-translate/core";
var UpdatedByLogService = /** @class */ (function () {
    function UpdatedByLogService(fuseTranslationLoaderService, translateService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translateService = translateService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    UpdatedByLogService.prototype.customUpdatedByInLogs = function (logs) {
        var _this = this;
        return logs.map(function (log) { return _this.generateUpdateByLog(log); });
    };
    UpdatedByLogService.prototype.generateUpdateByLog = function (log) {
        var logCustomAuthor = {
            type: this.getTypeLog(log),
            updatedBy: this.getUpdatedByLog(log),
            updatedByCompany: this.getUpdatedByCompanyLog(log),
            updatedBySource: this.getUpdatedBySourceLog(log)
        };
        var customAuthorParts = Object.values(logCustomAuthor).filter(Boolean);
        if (customAuthorParts.length >= 2) {
            log.customAuthorDevice = this.getCustomAuthorDeviceLog(log);
            log.customAuthor = customAuthorParts.join(' ');
        }
        return log;
    };
    UpdatedByLogService.prototype.getTypeLog = function (log) {
        if (log.isCreatedLog && (log.status === 'new' || log.snapshot && String(log.snapshot.status) === 'scheduled')) {
            return this.translateService.instant('MAINTENANCES.TABS.LOGS.CREATED');
        }
        return this.translateService.instant('MAINTENANCES.TABS.LOGS.UPDATED');
    };
    UpdatedByLogService.prototype.getUpdatedBySourceLog = function (log) {
        if (log.isCreatedLog && log.createdLogBy === 'recurrence') {
            return this.translateService.instant('MAINTENANCES.TABS.LOGS.PLATFORMS.SYSTEM_RECURRENCE');
        }
        var isMaintenanceChangedByEnterprise = !log.createdLogBy && log.typeLog === 'maintenance';
        var isTaskChangedByEnterprise = log.typeLog.includes('task') && log.updatedBy && log.updatedBy.type === 'customers';
        if (isMaintenanceChangedByEnterprise || isTaskChangedByEnterprise) {
            var clientApplication = String(log.clientApplicationName || 'BROWSER').toUpperCase();
            if (clientApplication.includes('API')) {
                clientApplication = 'API';
            }
            return this.translateService.instant("MAINTENANCES.TABS.LOGS.PLATFORMS." + clientApplication);
        }
        return null;
    };
    UpdatedByLogService.prototype.getUpdatedByCompanyLog = function (log) {
        var isMaintenance = log.typeLog === 'maintenance';
        var isSammathnaurUser = log.updatedBy && ['sammathnaur-user', 'customers'].includes(log.updatedBy.type);
        var isIntegration = log.updatedBy && log.updatedBy.type && log.updatedBy.type.includes('integration');
        var isEyeofSauronLog = log.createdLogBy === 'eyeofsauron';
        if (log.isCreatedLog && !isSammathnaurUser && isEyeofSauronLog) {
            return this.translateService.instant('MAINTENANCES.TABS.LOGS.BY_COMPANY', {
                company: log.company.name
            });
        }
        if (!isMaintenance && !isSammathnaurUser && !isIntegration && log.snapshot && log.snapshot.company) {
            return this.translateService.instant('MAINTENANCES.TABS.LOGS.BY_COMPANY', {
                company: log.snapshot.company.name
            });
        }
        if (isMaintenance && !isSammathnaurUser && isEyeofSauronLog && log.status === 'canceled') {
            return this.translateService.instant('MAINTENANCES.TABS.LOGS.BY_COMPANY', {
                company: log.company.name
            });
        }
        return null;
    };
    UpdatedByLogService.prototype.getUpdatedByLog = function (log) {
        if (log.updatedBy && log.updatedBy.name) {
            return this.translateService.instant('MAINTENANCES.TABS.LOGS.UPDATED_BY', {
                name: log.updatedBy && log.updatedBy.name
            });
        }
        return null;
    };
    UpdatedByLogService.prototype.getCustomAuthorDeviceLog = function (log) {
        var customAuthorDeviceMapper = {
            api: 'cloud',
            browser: 'laptop',
            system: 'settings',
            mobile: 'smartphone'
        };
        var device = (log.updatedBy && log.updatedBy['source']) || log.clientSource || log.clientApplicationName;
        if (!device) {
            return customAuthorDeviceMapper['browser'];
        }
        if (device.includes('api') || device.includes('integration')) {
            return customAuthorDeviceMapper['api'];
        }
        return customAuthorDeviceMapper[device];
    };
    UpdatedByLogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UpdatedByLogService_Factory() { return new UpdatedByLogService(i0.ɵɵinject(i1.FuseTranslationLoaderService), i0.ɵɵinject(i2.TranslateService)); }, token: UpdatedByLogService, providedIn: "root" });
    return UpdatedByLogService;
}());
export { UpdatedByLogService };
